/* IU-style rail: visible at the top, slides away on scroll down, returns on scroll up. */
(function () {
  function closeIsfNav() {
    var nav = document.querySelector('.mobile-nav-wrapper');
    var toggles = document.querySelectorAll('.js-mobile-nav-toggle');
    document.body.classList.remove('isf-nav-open');
    if (nav) {
      nav.classList.remove('js-menu--is-open');
      nav.style.setProperty('transform', 'translateX(-100%)', 'important');
    }
    for (var i = 0; i < toggles.length; i++) {
      toggles[i].classList.add('mobile-nav--open');
      toggles[i].classList.remove('mobile-nav--close');
    }
    if (window.jQuery) {
      window.jQuery(window).off('keyup.mobileNav');
      if (window.slate && window.slate.a11y) {
        window.slate.a11y.removeTrapFocus({
          $container: window.jQuery('#MobileNav'),
          namespace: 'navFocus'
        });
      }
    }
  }

  document.addEventListener('click', function (evt) {
    if (!document.body.classList.contains('isf-nav-open')) return;
    var node = evt.target;
    if (!node || !node.closest || !node.closest('[data-isf-nav-backdrop]')) return;
    evt.preventDefault();
    closeIsfNav();
  }, true);

  document.addEventListener('click', function (evt) {
    var buy = evt.target && evt.target.closest && evt.target.closest('#IsfPdpBuyNow');
    if (!buy || buy.disabled) return;
    evt.preventDefault();
    var form = document.getElementById('AddToCartForm');
    if (!form) return;
    var ret = form.querySelector('input[name="return_to"]');
    if (!ret) {
      ret = document.createElement('input');
      ret.type = 'hidden';
      ret.name = 'return_to';
      form.appendChild(ret);
    }
    ret.value = '/checkout';
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  });

  /* Color / size chips: do not use preventDefault or closest('.isf-pdp .chip').
     After the first variant change, theme.js called slick('slickGoTo') on a
     gallery that is not a slider, threw, and never updated currentVariant —
     so the next chip click compared against a stale variant and did nothing. */
  function isfPdpProduct() {
    var jsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!jsonEl) return null;
    try { return JSON.parse(jsonEl.textContent); } catch (e) { return null; }
  }
  function isfSelectedOptions(root) {
    var opts = [];
    var swatches = root.querySelectorAll('.swatch');
    for (var i = 0; i < swatches.length; i++) {
      var idx = parseInt(swatches[i].getAttribute('data-option-index'), 10);
      var checked = swatches[i].querySelector('input[type="radio"]:checked');
      if (!isNaN(idx) && checked) opts[idx] = checked.value;
    }
    return opts;
  }
  function isfFindVariant(product, opts) {
    if (!product || !product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var values = v.options || [v.option1, v.option2, v.option3];
      var ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] == null) continue;
        if (String(values[j]) !== String(opts[j])) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function isfShowVariantImage(root, variant) {
    if (!variant || !variant.featured_image) return;
    var imageId = String(variant.featured_image.id);
    var photos = root.querySelectorAll('.product-single__photo[data-image-id]');
    for (var i = 0; i < photos.length; i++) {
      var on = String(photos[i].getAttribute('data-image-id')) === imageId;
      photos[i].classList.toggle('hide', !on);
    }
    var thumbs = root.querySelectorAll('.product-single__thumbnail[data-thumbnail-id]');
    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].classList.toggle(
        'active-thumb',
        String(thumbs[t].getAttribute('data-thumbnail-id')) === imageId
      );
    }
  }
  document.addEventListener('click', function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var chip = evt.target.closest('.swatch-element');
    if (!chip) return;
    var root = chip.closest('.isf-pdp');
    if (!root) return;
    var radio = chip.querySelector('input[type="radio"]');
    if (!radio) return;
    radio.disabled = false;
    radio.checked = true;

    var product = isfPdpProduct();
    var variant = isfFindVariant(product, isfSelectedOptions(root));
    if (!variant) return;

    var optIdx = chip.closest('.swatch') && chip.closest('.swatch').getAttribute('data-option-index');
    var select = optIdx !== null ? document.getElementById('SingleOptionSelector-' + optIdx) : null;
    if (select) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === radio.value) {
          select.selectedIndex = i;
          break;
        }
      }
    }
    var master = root.querySelector('select[name="id"]');
    if (master) {
      master.value = String(variant.id);
    }

    isfShowVariantImage(root, variant);

    if (select && window.jQuery) {
      try { window.jQuery(select).trigger('change'); } catch (e) {}
    }
  });

  function isfFixPdpGallery() {
    if (!window.jQuery) return;
    if (!document.querySelector('.isf-pdp')) return;
    if (!window.matchMedia('(min-width: 990px)').matches) return;
    var $thumbs = window.jQuery('.isf-pdp .product-single__thumbnails');
    if ($thumbs.length && $thumbs.hasClass('slick-initialized')) {
      try { $thumbs.slick('unslick'); } catch (e) {}
    }
  }
  window.addEventListener('load', function () {
    isfFixPdpGallery();
    [200, 600, 1200].forEach(function (ms) {
      setTimeout(isfFixPdpGallery, ms);
    });
  });
  window.addEventListener('resize', isfFixPdpGallery);

  function isfSoftenPdpTitle() {
    var title = document.querySelector('.isf-pdp .product-single__title');
    if (!title) return;
    var raw = (title.textContent || '').trim();
    if (raw.length < 5) return;
    var letters = raw.replace(/[^A-Za-z]/g, '');
    if (!letters || letters !== letters.toUpperCase()) return;
    title.textContent = raw.toLowerCase().replace(/(^|[\s/&-])([a-z])/g, function (_, a, b) {
      return a + b.toUpperCase();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', isfSoftenPdpTitle);
  } else {
    isfSoftenPdpTitle();
  }

  (function gateHomeChips() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var chips = document.querySelector('.isf-chips--after-cats');
    var cats = document.querySelector('.isf-circles-section') || document.querySelector('.isf-circles');
    if (!chips) return;
    if (!cats) {
      chips.classList.add('is-visible');
      return;
    }
    var header = document.querySelector('.isf-header-section') ||
      document.getElementById('shopify-section-header');
    function update() {
      var catBottom = cats.getBoundingClientRect().bottom;
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      chips.classList.toggle('is-visible', catBottom <= headerBottom + 4);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();

  var layout = document.querySelector('.isf-layout');
  var sidebar = layout && layout.querySelector('.isf-sidebar');
  if (!layout || !sidebar) return;
  if (window.matchMedia('(max-width: 749px)').matches) return;
  if (layout.classList.contains('is-sidebar-off') || document.body.classList.contains('template-product')) {
    layout.classList.add('is-sidebar-away');
    return;
  }

  var edge = layout.querySelector('.isf-sidebar-edge');
  var cats = document.querySelector('.isf-circles-section') || document.querySelector('.isf-circles');
  var gated = layout.classList.contains('is-sidebar-gated') || !!cats;

  function headerEl() {
    return document.querySelector('.isf-header-section') ||
      document.getElementById('shopify-section-header') ||
      document.querySelector('.site-header');
  }

  function setHeaderHeight() {
    var header = headerEl();
    var h = header ? Math.round(header.getBoundingClientRect().height) : 80;
    document.documentElement.style.setProperty('--isf-header-h', h + 'px');
  }

  function pastCategorySection() {
    if (!gated || !cats) return true;
    var header = headerEl();
    var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    return cats.getBoundingClientRect().bottom <= headerBottom + 4;
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  var header = headerEl();
  if (header && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(setHeaderHeight).observe(header);
  }

  var lastY = window.scrollY || 0;
  var hovering = false;

  function hide() {
    if (hovering && pastCategorySection()) return;
    layout.classList.add('is-sidebar-away');
  }

  function show() {
    if (!pastCategorySection()) {
      layout.classList.add('is-sidebar-away');
      return;
    }
    layout.classList.remove('is-sidebar-away');
  }

  window.addEventListener('scroll', function () {
    if (!pastCategorySection()) {
      hovering = false;
      hide();
      lastY = window.scrollY || 0;
      return;
    }
    if (gated) {
      show();
      lastY = window.scrollY || 0;
      return;
    }
    var y = window.scrollY || 0;
    if (y < 40) {
      show();
    } else if (y > lastY + 6) {
      hide();
    } else if (y < lastY - 6) {
      show();
    }
    lastY = y;
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (pastCategorySection()) show();
    else hide();
  });

  show();

  sidebar.addEventListener('mouseenter', function () {
    if (!pastCategorySection()) return;
    hovering = true;
    show();
  });
  sidebar.addEventListener('mouseleave', function () {
    hovering = false;
    if (!gated && (window.scrollY || 0) >= 40) hide();
  });

  if (edge) {
    edge.addEventListener('mouseenter', function () {
      if (!pastCategorySection()) return;
      hovering = true;
      show();
    });
    edge.addEventListener('mouseleave', function () {
      hovering = false;
      if (!gated && (window.scrollY || 0) >= 40) hide();
    });
  }
})();

(function hideAliReviewsTab() {
  window.__AR_WIDGET_REVIEW_TAB = 0;
  function hide() {
    var nodes = document.querySelectorAll(
      '[id*="review-tab"], [id*="review_tab"], [class*="review-tab"], [class*="review_tab"], [class*="ReviewTab"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest && (el.closest('.alireviews-review-box') || el.closest('.isf-pdp__reviews'))) continue;
      el.style.setProperty('display', 'none', 'important');
    }
    var fixed = document.querySelectorAll('body > div, body > aside, #MainContent ~ div');
    for (var j = 0; j < fixed.length; j++) {
      var node = fixed[j];
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (text !== 'Reviews' && text.indexOf('Reviews') !== 0) continue;
      var style = window.getComputedStyle(node);
      if (style.position !== 'fixed' && style.position !== 'sticky') continue;
      if (node.closest && (node.closest('.alireviews-review-box') || node.closest('.isf-pdp__reviews'))) continue;
      node.style.setProperty('display', 'none', 'important');
    }
  }
  hide();
  var obs = new MutationObserver(hide);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    obs.disconnect();
    hide();
  }, 10000);
})();

(function styleChatBubble() {
  function apply(host) {
    if (!host || !host.shadowRoot) return;
    var labels = host.shadowRoot.querySelectorAll('.activator__label');
    for (var i = 0; i < labels.length; i++) labels[i].setAttribute('hidden', '');
    if (host.shadowRoot.querySelector('style[data-isf-chat-bubble]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-isf-chat-bubble', '1');
    st.textContent =
      '.activator-nudge,.activator{pointer-events:auto!important;}' +
      '@keyframes isfChatPulse{0%,100%{box-shadow:0 8px 22px rgba(82,83,46,.42),0 0 0 0 rgba(82,83,46,.28)}70%{box-shadow:0 8px 22px rgba(82,83,46,.42),0 0 0 12px rgba(82,83,46,0)}}' +
      '.activator{' +
      '--activator-bg:#52532E;--activator-fg:#fff;' +
      'width:56px!important;height:56px!important;padding-inline:0!important;justify-content:center;' +
      'border-radius:50%!important;border:2px solid #fff;cursor:pointer;' +
      'animation:isfChatPulse 2.6s ease-out infinite;}' +
      '.activator:hover{animation:none;}' +
      '.activator__label{display:none!important;}' +
      '.activator__icon,.activator__icon svg{color:#fff;stroke:#fff;}';
    host.shadowRoot.appendChild(st);
  }
  function run() {
    var nodes = document.querySelectorAll('shopify-chat');
    for (var i = 0; i < nodes.length; i++) apply(nodes[i]);
  }
  run();
  var obs = new MutationObserver(run);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () {
    obs.disconnect();
    run();
  }, 12000);
})();

